export default __webpack_public_path__ + "static/media/CIA-Hot-Works-Permit-2023.adbe2e6e.pdf";